export const APP_VERSION = '2.28.48';
